import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { DiagnosisHelper } from "@/Patient/Helpers/DiagnosisHelper";
import { DiagnosisModel } from "@/Patient/Models/MedicalSummary/DiagnosisModel";
import { FavoriteDiagnosisComposite } from "@/Patient/Models/MedicalSummary/FavoriteDiagnosisComposite";
import { patientStore } from "@/Patient/Stores/PatientStore";

import styles from "./FavoriteDiagnosisSearchItem.module.css";

import img_icon_addfavorite from "@/Globals/_images/icons/AddFavorite.png";
import img_icon_favorite from "@/Globals/_images/icons/Favorite.png";

interface IFavoriteDiagnosisSearchItemProps {
    id: string;
    dataCy?: string;
    isFavorite: boolean;
    item: DiagnosisModel;
    style?: React.CSSProperties;
    hyperlinkStyle?: React.CSSProperties;
    onFavoriteToggleClick?: () => void;
}

class FavoriteDiagnosisSearchItemState {
    public isActive: boolean;
    public isFavorite: boolean;

    constructor(isFavorite: boolean) {
        this.isFavorite = isFavorite;
    }
}

class FavoriteDiagnosisSearchItem extends BaseReactComponent<IFavoriteDiagnosisSearchItemProps, FavoriteDiagnosisSearchItemState> {
    constructor(props: IFavoriteDiagnosisSearchItemProps) {
        super(props);

        this.state = new FavoriteDiagnosisSearchItemState(props.isFavorite);
    }

    public render(): JSX.Element {
        const isFavorite = this.state.isFavorite;

        return (
            <div className="flex-container" style={{ ...this.props.style, justifyContent: "flex-start" }}>
                <div>
                    <div className={`${styles.imageContainer} pointer`} onClick={this.toggleAddAsFavorite.bind(this)}>
                        <img className={styles.image} id={isFavorite ? "_setFavOn" : "_setFavOff"} src={isFavorite ? img_icon_favorite : img_icon_addfavorite} />
                    </div>
                </div>
                <div>
                    {this.props.item.Model.DiagnosisItems?.map(item => {
                        var lookupValue = cacheStore.GetLocalizedValueByLookupId(item.StatusLookupId);
                        var spandata = lookupValue
                            ? (item.Code ? <span style={{ color: "#0070d2" }}>{`${item.Code} ${item.Text} (${lookupValue}) - `}</span>
                                : <span style={{ color: "#0070d2" }}>{`${item.Text} (${lookupValue})`}</span>)
                            : (item.Code ? <span style={{ color: "#0070d2" }}>{`${item.Code} ${item.Text} - `}</span>
                                : <span style={{ color: "#0070d2" }}>{`${item.Text}`}</span>);
                        return (
                            <div key={item.Id} style={{ margin: "2px 0px 0px 5px" }}>
                                {!IsNullOrUndefined(item.SourceDictionary) && (
                                    <a style={this.props.hyperlinkStyle}>
                                        {spandata}
                                        <span style={{ fontStyle: "italic" }}>{`${DiagnosisHelper.getSourceNameFromCode(item.SourceDictionary)}`}</span>
                                    </a>
                                )}
                                {IsNullOrUndefined(item.SourceDictionary) && (
                                    <a style={this.props.hyperlinkStyle}>
                                        {spandata}
                                    </a>
                                )}
                            </div>
                        );
                    })}
                    <div className={styles.description}>
                        <span>{`${this.props.item.Model.ProblemDescription}`}</span>
                    </div>
                </div>
            </div>
        );
    }

    private toggleAddAsFavorite(e: React.SyntheticEvent): void {
        e.stopPropagation();
        this.removeFavorite(this.props.id, this.props.item.Model, this.state.isFavorite);
        this.setState({ isFavorite: !this.state.isFavorite });
        this.props?.onFavoriteToggleClick();
    }

    private removeFavorite(diagnosisId: string, favoriteDiagnosis: FavoriteDiagnosisComposite, isRemove: boolean): void {
        patientStore.ActionsMedicationTab.ToggleFavoriteMedicalProblem(diagnosisId, favoriteDiagnosis, isRemove, true);
    }
}

export default FavoriteDiagnosisSearchItem;
